module.exports = __webpack_public_path__ + "media/react/gre/adaptive_prep_v2/assets/icons/checkmark_icon-36e0bbd606285e990416ba18b1fa79c7.svg";